import React, { useState, useEffect, useRef } from 'react';
import DataTable from 'react-data-table-component';
import { IoTrashOutline } from "react-icons/io5";
import { LuPencilLine } from "react-icons/lu";
import { FaFilePdf } from "react-icons/fa6";
import { FaEye } from "react-icons/fa";
import AgregarProforma from './AgregarProforma';
import EditarProforma from './EditarProforma';
import VerProforma from './VerProforma';
import GenerarPDF from './GenerarPDF';
import { Modal, Button, Spinner } from 'react-bootstrap';
import { urlApiProd, print } from '../utiles';
import PageHeader from '../../components/PageHeader/PageHeader';
import Toolbar from '../../components/Toolbar/Toolbar';
import '../../components/ui.css';

const formatDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getUTCFullYear();
    const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
    const day = date.getUTCDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
};

const Proformas = () => {
    const [loading, setLoading] = useState(true);
    const [dataProformas, setDataProformas] = useState([]);
    const [dataClientes, setDataClientes] = useState([]);
    const [dataSubClientes, setDataSubClientes] = useState([]);
    const [dataIncoTerms, setDataIncoTerms] = useState([]);
    const [dataPuertos, setDataPuertos] = useState([]);
    const [dataProductos, setDataProductos] = useState([]);
    const [dataDocumentos, setDataDocumentos] = useState([]);
    const [dataUsuarios, setDataUsuarios] = useState([]);
    const [dataCategorias, setDataCategorias] = useState([]);
    const [dataMedidas, setDataMedidas] = useState([]);
    const [dataCalidades, setDataCalidades] = useState([]);
    const [dataEspecies, setDataEspecies] = useState([]);
    const [dataShippingDocs, setDataShippingDocs] = useState([]);
    const [dataPaymentTerms, setDataPaymentTerms] = useState([]);
    const firstRender = useRef(true);
    const [showAgregar, setShowAgregar] = useState(false);
    const [showEditar, setShowEditar] = useState(false);
    const [showVer, setShowVer] = useState(false);
    const [selected, setSelected] = useState(null);
    const [filterText, setFilterText] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const [showPDF, setShowPDF] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [modalContent, setModalContent] = useState({ title: '', body: '', variant: '' });


    const fetchData = async () => {
        const token = localStorage.getItem('token'); // Obtener token de autenticación
        try {
            const responseProformas = await fetch(`${urlApiProd}/proformas`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            if (responseProformas.status === 401) {
                throw new Error('Unauthorized');
            }
            const dataProformas = await responseProformas.json();
            setDataProformas(dataProformas);

            const responseClientes = await fetch(`${urlApiProd}/clientes`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            if (responseClientes.status === 401) {
                throw new Error('Unauthorized');
            }
            const dataClientes = await responseClientes.json();
            setDataClientes(dataClientes);

            const responseincoterms = await fetch(`${urlApiProd}/incoterms`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            if (responseincoterms.status === 401) {
                throw new Error('Unauthorized');
            }
            const dataincoterms = await responseincoterms.json();
            setDataIncoTerms(dataincoterms);

            const responsePuertos = await fetch(`${urlApiProd}/puertos`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            if (responsePuertos.status === 401) {
                throw new Error('Unauthorized');
            }
            const dataPuertos = await responsePuertos.json();
            setDataPuertos(dataPuertos);

            const responseProductos = await fetch(`${urlApiProd}/productos`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            if (responseProductos.status === 401) {
                throw new Error('Unauthorized');
            }
            const dataProductos = await responseProductos.json();
            setDataProductos(dataProductos);

            const responseDocumentos = await fetch(`${urlApiProd}/documentos`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            if (responseDocumentos.status === 401) {
                throw new Error('Unauthorized');
            }
            const dataDocumentos = await responseDocumentos.json();
            setDataDocumentos(dataDocumentos);

            const responseUsuarios = await fetch(`${urlApiProd}/usuarios`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            if (responseUsuarios.status === 401) {
                throw new Error('Unauthorized');
            }
            const dataUsuarios = await responseUsuarios.json();
            setDataUsuarios(dataUsuarios);

            const responseCategorias = await fetch(`${urlApiProd}/categorias`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            if (responseCategorias.status === 401) {
                throw new Error('Unauthorized');
            }
            const dataCategorias = await responseCategorias.json();
            setDataCategorias(dataCategorias);

            const responseMedidas = await fetch(`${urlApiProd}/medidas`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            if (responseMedidas.status === 401) {
                throw new Error('Unauthorized');
            }
            const dataMedidas = await responseMedidas.json();
            setDataMedidas(dataMedidas);

            const responseCalidades = await fetch(`${urlApiProd}/calidades`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            if (responseCalidades.status === 401) {
                throw new Error('Unauthorized');
            }
            const dataCalidades = await responseCalidades.json();
            setDataCalidades(dataCalidades);

            const responseEspecies = await fetch(`${urlApiProd}/especies`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            if (responseEspecies.status === 401) {
                throw new Error('Unauthorized');
            }
            const dataEspecies = await responseEspecies.json();
            setDataEspecies(dataEspecies);

            const responseShippingDocs = await fetch(`${urlApiProd}/shippingdocs`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            if (responseShippingDocs.status === 401) {
                throw new Error('Unauthorized');
            }
            const dataShippingDocs = await responseShippingDocs.json();
            setDataShippingDocs(dataShippingDocs);

            const responseSubClientes = await fetch(`${urlApiProd}/subclientes`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            if (responseSubClientes.status === 401) {
                throw new Error('Unauthorized');
            }
            const dataSubClientes = await responseSubClientes.json();
            setDataSubClientes(dataSubClientes);

            const ptResponse = await fetch(`${urlApiProd}/paymentterms`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            if (ptResponse.status === 401) {
                throw new Error('Unauthorized');
            }
            const ptData = await ptResponse.json();
            setDataPaymentTerms(ptData);

            setLoading(false);
        } catch (error) {
            console.error('Error fetching data:', error);
            setLoading(false);
            showModalPopup('Error', 'Error recibiendo los datos', 'danger');
        }
    };

    const showModalPopup = (title, body, variant) => {
        setModalContent({ title, body, variant });
        setShowModal(true);
    };

    const handleCloseModal = () => setShowModal(false);

    useEffect(() => {
        if (firstRender.current) {
            fetchData();
            firstRender.current = false;
        }
    }, []);

    useEffect(() => {
        if (!Array.isArray(dataProformas)) {
            setFilteredData([]);
            return;
        }
        const sortedData = dataProformas.slice().sort((a, b) => {
            const dateA = a.fecha_creacion ? new Date(a.fecha_creacion) : new Date(0);
            const dateB = b.fecha_creacion ? new Date(b.fecha_creacion) : new Date(0);
            if (dateB - dateA !== 0) return dateB - dateA;

            const docDateA = a.fecha ? new Date(a.fecha) : new Date(0);
            const docDateB = b.fecha ? new Date(b.fecha) : new Date(0);
            if (docDateB - docDateA !== 0) return docDateB - docDateA;

            return b.id_proforma - a.id_proforma;
        });
        const filtered = sortedData.filter((row) => {
            // Busqueda por defecto en los valores de la fila
            const matchRow = Object.values(row).some((value) =>
                value?.toString().toLowerCase().includes(filterText.toLowerCase())
            );

            // Busqueda por nombre de cliente
            let matchCliente = false;
            if (row.cliente) {
                const clienteObj = dataClientes.find(cli => cli.id_cliente === row.cliente);
                if (clienteObj && clienteObj.nombre.toLowerCase().includes(filterText.toLowerCase())) {
                    matchCliente = true;
                }
            }

            return matchRow || matchCliente;
        });
        setFilteredData(filtered);
    }, [dataProformas, filterText, dataClientes]);

    const columns = [
        {
            name: 'Editar',
            cell: (row) => <button className='btn btn-outline-primary' onClick={() => handleEditar(row)}><LuPencilLine /></button>,
        },
        {
            name: 'Correlativo',
            selector: row => parseInt(row.correlativo), sortable: true, reorder: true,
            width: '80px',
        },

        {
            name: 'Cliente',
            selector: row => {
                let cliente = row.cliente ? dataClientes.find(cli => cli.id_cliente === row.cliente) : null;
                return cliente ? cliente.nombre : "undefined"
            }, sortable: true, reorder: true,
            width: '300px',
        },
        {
            name: 'Fecha',
            selector: row => formatDate(row.fecha), sortable: true, reorder: true,
        },
        {
            name: 'Fecha Embarque',
            selector: row => formatDate(row.fecha_embarque), sortable: true, reorder: true,
        },
        {
            name: 'Valor',
            selector: row => row.valor_proforma ? parseFloat(row.valor_proforma).toFixed(2) : 'error',
        },

        {
            name: 'Moneda',
            selector: row => row.moneda === 0 ? "USD" : row.moneda === 1 ? "EUR" : row.moneda === 2 ? "CLP" : row.moneda === 3 ? "BRL" : row.moneda === 4 ? "PYG" : "Indefinido", sortable: true, reorder: true,
        },
        {
            name: 'Estado',
            selector: row => row.estado === 0 ? "borrador" : row.estado === 1 ? "Por aprobar" : row.estado === 2 ? "Aprobada" : row.estado === 3 ? "Aprobada x Cliente" : row.estado === 4 ? "Rechazada" : "Indefinido", sortable: true, reorder: true,
        },
        {
            name: 'Acciones',
            cell: row => (
                <div>
                    <button className='btn btn-outline-primary mr-2' onClick={() => handleVerProforma(row)}>
                        <FaEye />
                    </button>
                    <button className='btn btn-outline-primary mr-2' onClick={() => handleGenerarPDF(row)}>
                        <FaFilePdf />
                    </button>
                    <button
                        className='btn btn-outline-danger'
                        onClick={() => {
                            if (window.confirm('¿Estás seguro?')) {
                                handleEliminar(row['id_proforma']);
                            }
                        }}
                    >
                        <IoTrashOutline />
                    </button>
                </div>
            ),
            ignoreRowClick: true,
        }
    ]

    const handleAgregar = () => {
        setShowAgregar(true);
    };

    const handleEditar = (proforma) => {
        setSelected(proforma);
        setShowAgregar(false);
        setShowVer(false);
        setShowPDF(false);
        setShowEditar(true);
    };

    const handleSaveEditar = (edited) => {
        print(`handleSaveEditar ${edited.id_proforma}`);
        const token = localStorage.getItem('token');
        fetch(`${urlApiProd}/editarproforma/${edited.id_proforma}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(edited),
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Error al actualizar datos');
                }
                return response.json();
            })
            .then(data => {
                console.log('Datos actualizados:', data);
                alert('Datos actualizados exitosamente');
                window.location.reload();
            })
            .catch(error => {
                console.error('Error:', error);
            });
    };

    const handleCloseEditar = () => {
        setSelected(null);
        setShowEditar(false)
    };

    const handleEliminar = (idAEliminar) => {
        const token = localStorage.getItem('token'); // Obtener token de autenticación
        fetch(`${urlApiProd}/eliminarproforma/${idAEliminar}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        })
            .then(response => {
                if (response.ok) {
                    alert('Datos Eliminados Correctamente.');
                    window.location.reload();
                } else {
                    alert('Error al intentar eliminar datos.')
                }
            })
            .catch(error => {
                console.error('Error de red:', error);
            });
    }

    const handleVerProforma = (proforma) => {
        setSelected(proforma);
        setShowVer(true);
    }
    const handleCloseVerProforma = () => {
        setSelected(null);
        setShowVer(false)
    }

    const handleGenerarPDF = (proforma) => {
        setSelected(proforma);
        setShowPDF(true);
    }

    return (
        <div className='container-fluid ui-page'>
            <PageHeader
                eyebrow="Generar · Comercial"
                title="Proformas Invoice"
                descripcion="Creación y seguimiento de proformas invoice, con sus productos y condiciones de pago."
                actions={
                    <button type="button" className="ui-btn ui-btn-primary" onClick={() => handleAgregar()}>Agregar Proforma</button>
                }
            />
            <div className='card'>
                <div className='card-body mb-2'>
                    {/* Modal para mostrar el pop-up */}
                    <Modal show={showModal} onHide={handleCloseModal} centered>
                        <Modal.Header closeButton className={modalContent.variant === 'success' ? 'title-success' : 'title-danger'}>
                            <Modal.Title>
                                {modalContent.title}
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>{modalContent.body}</Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleCloseModal}>
                                Cerrar
                            </Button>
                        </Modal.Footer>
                    </Modal>
                    {loading ? (
                        <>
                            <div className="text-center">
                                <Spinner animation="border" role="status" />
                            </div>
                            <div className='text-center'>
                                <span className="sr-only">Cargando...</span>
                            </div>
                        </>
                    ) : (
                        <>
                            <Toolbar
                                left={
                                    <input
                                        type="text"
                                        placeholder="Buscar..."
                                        value={filterText}
                                        onChange={(e) => setFilterText(e.target.value)}
                                        className='form-control'
                                    />
                                }
                            />
                            {showAgregar &&
                                <AgregarProforma clientes={dataClientes} subclientes={dataSubClientes} incoterms={dataIncoTerms} puertos={dataPuertos} productos={dataProductos} documentos={dataDocumentos} usuarios={dataUsuarios} categorias={dataCategorias} especies={dataEspecies} medidas={dataMedidas} calidades={dataCalidades} pt={dataPaymentTerms} proformas={dataProformas} cerrar={() => setShowAgregar(false) && fetchData()} />
                            }
                            <div className="card">
                                <div className="card-body">
                                    <DataTable
                                        columns={columns}
                                        data={filteredData}
                                        noHeader
                                        responsive
                                        pagination
                                        highlightOnHover
                                    />
                                </div>
                            </div>
                            {selected && showEditar && (
                                <EditarProforma proforma={selected} clientes={dataClientes} subclientes={dataSubClientes} incoterms={dataIncoTerms} puertos={dataPuertos} productos={dataProductos} documentos={dataDocumentos} usuarios={dataUsuarios} categorias={dataCategorias} especies={dataEspecies} medidas={dataMedidas} calidades={dataCalidades} pt={dataPaymentTerms} cerrar={handleCloseEditar} guardar={handleSaveEditar}
                                />
                            )}
                            {selected && showVer && (
                                <VerProforma proforma={selected} clientes={dataClientes} incoterms={dataIncoTerms} puertos={dataPuertos} productos={dataProductos} documentos={dataDocumentos} usuarios={dataUsuarios} categorias={dataCategorias} especies={dataEspecies} medidas={dataMedidas} calidades={dataCalidades} proformas={dataProformas} pt={dataPaymentTerms} guardar={handleSaveEditar} cerrar={handleCloseVerProforma} />
                            )}
                            {!showVer && !showEditar && showPDF && selected && (
                                <GenerarPDF proforma={selected} clientes={dataClientes} incoterms={dataIncoTerms} puertos={dataPuertos} productos={dataProductos} documentos={dataDocumentos} usuarios={dataUsuarios} categorias={dataCategorias} especies={dataEspecies} medidas={dataMedidas} calidades={dataCalidades} proformas={dataProformas} shippingdocs={dataShippingDocs} pt={dataPaymentTerms} cerrar={handleCloseVerProforma} />
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
    )
}

export default Proformas
